import { FaqCommunications } from "@kunduz/ui-components";
import React, { ReactElement } from "react";

export const TrFaqCommunications = (): ReactElement => {
  return (
    <FaqCommunications
      title="Aradığınız sorunun cevabını bulamadınız mı?"
      supportingText="Aradığınızı burda bulamadıysanız ekibimizle görüşme başlatabilirsiniz. Ekibimiz en kısa süre içerisinde size yardımcı olmaya çalışacak."
      ctaLabel="Detaylı Bilgi Al"
      onCtaClick={() => {
        return;
      }}
      avatarUrls={["", "", ""]}
    />
  );
};
